import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { TagEntity } from './tag.entity'

export class TagsRepository extends BaseRepository<TagEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/' + 'tags', token, cache)
    }

    async getTaggedPersons(from: Date, to: Date, lastEventBased, tag: string = '', rangeFrom: number, rangeTo: number) {
        const { json, statusCode, message } = await this.request.get(
            this.config.eventApiUrl +
                '/persons/tagged?tag=' +
                tag +
                '&from=' +
                from +
                '&to=' +
                to +
                '&rangeFrom=' +
                rangeFrom +
                '&rangeTo=' +
                rangeTo +
                '&lastEventBased=' +
                lastEventBased +
                '&token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async addPerson(tagId: string, personId: string) {
        const { json, statusCode, message } = await this.request.post(
            this.config.eventApiUrl + '/tags/' + tagId + '/persons/?token=' + this.resolvedToken,
            { personId },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async removePerson(tagId: string, personId: string) {
        const { json, statusCode, message } = await this.request.delete(
            this.config.eventApiUrl + '/tags/' + tagId + '/persons/?token=' + this.resolvedToken,
            { personId },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
